import { memo } from 'react';
import { useHistory } from 'react-router-dom';
import { useStateSelector } from 'hooks';
import { ContactInformationWidgetModel } from 'models/ContactInformationWidgetModel';

import { WidgetContainer } from 'components';
import Card from './card';
import Box from '@material-ui/core/Box';

import { useStyles } from './style';

interface Props {
  widgetData: ContactInformationWidgetModel;
}

const ContactInformationWidget = ({ widgetData }: Props) => {
  const history = useHistory();
  const classes = useStyles();
  const portal = useStateSelector((state) => state.settings.current_portal);

  const forwardToServiceProvidersPage = () => {
    let url = '/service-providers';

    if (portal?.Name === 'Maintenance') {
      url = '/maintenance/service-providers';
    }

    history.push(url);
  };

  return (
    <WidgetContainer
      themeColor="darkBlue"
      title={'Kaikki yhteystiedot'}
      action={forwardToServiceProvidersPage}
    >
      <Box padding="15px">
        <h2 className={classes.widgetTitle}>Yhteystiedot</h2>
      </Box>
      <Box display="flex" flexWrap="wrap" flexDirection="row">
        {widgetData.PropertyMaintenance ? (
          <Box className={classes.box}>
            <h3 className={classes.title}>
              {widgetData.PropertyMaintenance.Title}
            </h3>
            <Card
              description={widgetData.PropertyMaintenance.Description}
              role={widgetData.PropertyMaintenance.Role}
              name={widgetData.PropertyMaintenance.Name}
              email={widgetData.PropertyMaintenance.Email}
              phone={widgetData.PropertyMaintenance.Phone}
              emergencyPhone={widgetData.PropertyMaintenance.EmergencyPhone}
              imgSrc={widgetData.PropertyMaintenance.Image}
            />
          </Box>
        ) : null}

        {widgetData.PropertyManager ? (
          <Box className={classes.box}>
            <h3 className={classes.title}>
              {widgetData.PropertyManager.Title}
            </h3>
            <Card
              description={widgetData.PropertyManager.Description}
              role={widgetData.PropertyManager.Role}
              name={widgetData.PropertyManager.Name}
              email={widgetData.PropertyManager.Email}
              imgSrc={widgetData.PropertyManager.Image}
              phone={widgetData.PropertyManager.Phone}
              emergencyPhone={widgetData.PropertyManager.EmergencyPhone}
            />
          </Box>
        ) : null}

        {widgetData.Accountant ? (
          <Box className={classes.box}>
            <h3 className={classes.title}>{widgetData.Accountant.Title}</h3>
            <Card
              description={widgetData.Accountant.Description}
              role={widgetData.Accountant.Role}
              name={widgetData.Accountant.Name}
              email={widgetData.Accountant.Email}
              imgSrc={widgetData.Accountant.Image}
              phone={widgetData.Accountant.Phone}
              emergencyPhone={widgetData.Accountant.EmergencyPhone}
            />
          </Box>
        ) : null}
      </Box>
    </WidgetContainer>
  );
};

export default memo(ContactInformationWidget);
